(function() {
  'use strict';

  // ===== Gallery (main image + thumbnails) =====
  const gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;

  const slides = gallery.querySelectorAll('[data-gallery-slide]');
  const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  const main = gallery.querySelector('[data-gallery-main]');
  let currentIndex = 0;

  function showSlide(index) {
    if (index < 0 || index >= slides.length) return;
    slides.forEach(s => s.classList.remove('is-active'));
    thumbs.forEach(t => t.classList.remove('is-active'));
    slides[index].classList.add('is-active');
    if (thumbs[index]) thumbs[index].classList.add('is-active');
    currentIndex = index;
  }

  thumbs.forEach(btn => {
    btn.addEventListener('click', () => showSlide(parseInt(btn.dataset.galleryThumb)));
  });

  // ===== Lightbox =====
  const lightbox = document.querySelector('[data-lightbox]');
  const lightboxImg = lightbox.querySelector('[data-lightbox-img]');
  const lightboxCounter = lightbox.querySelector('[data-lightbox-counter]');
  const zoomButtons = gallery.querySelectorAll('[data-gallery-zoom]');

  function openLightbox(index) {
    if (!lightbox || !slides[index]) return;
    const img = slides[index].querySelector('img');
    lightboxImg.src = img.src.replace(/[?&]width=\d+/, '') + '&width=2000';
    lightboxImg.alt = img.alt;
    lightboxCounter.textContent = (index + 1) + ' / ' + slides.length;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    currentIndex = index;
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  zoomButtons.forEach(btn => {
    btn.addEventListener('click', () => openLightbox(parseInt(btn.dataset.galleryZoom)));
  });

  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
  lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', () => {
    let i = currentIndex - 1;
    if (i < 0) i = slides.length - 1;
    openLightbox(i);
  });
  lightbox.querySelector('[data-lightbox-next]').addEventListener('click', () => {
    let i = currentIndex + 1;
    if (i >= slides.length) i = 0;
    openLightbox(i);
  });

  // Keyboard nav
  document.addEventListener('keydown', (e) => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lightbox.querySelector('[data-lightbox-prev]').click();
    if (e.key === 'ArrowRight') lightbox.querySelector('[data-lightbox-next]').click();
  });

  // Click outside image to close
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  // ===== Product card image hover =====
  document.querySelectorAll('[data-product-card]').forEach(card => {
    const imgs = card.querySelectorAll('[data-card-image]');
    if (imgs.length < 2) return;
    card.addEventListener('mouseenter', () => {
      imgs[0].style.opacity = '0';
      imgs[1].style.opacity = '1';
    });
    card.addEventListener('mouseleave', () => {
      imgs[0].style.opacity = '1';
      imgs[1].style.opacity = '0';
    });
  });

})();


// ===== Scroll Animations =====
document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.custom-story__grid, .custom-featured__header, .custom-featured__card, .custom-hero__content').forEach(el => {
    el.classList.add('fade-in');
    observer.observe(el);
  });

  // Floating discount tooltip
  const badge = document.querySelector('.floating-discount');
  const tooltip = document.getElementById('discount-tooltip');
  if (badge && tooltip) {
    badge.addEventListener('mouseenter', () => tooltip.classList.add('show'));
    badge.addEventListener('mouseleave', () => tooltip.classList.remove('show'));
  }
});
